/* istanbul ignore file */
import React from 'react';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';
import { useFieldHelper } from 'framework/ui/field';
import { useAuthorization } from 'framework/authorization';
import { EditButtonProps, LinkButton } from 'framework/ui/ui-builder';

interface PublishVacancyButtonProps extends EditButtonProps {
  isVisible?: (value: any) => boolean;
  width?: number;
}

const PublishVacancyButton = ({ permissionToCheck, ...props }: PublishVacancyButtonProps) => {
  const { getCreateUrl } = useVacancyPublicationUrl();
  const { getValue } = useFieldHelper(props);
  const { isGranted } = useAuthorization();

  return !permissionToCheck || isGranted(permissionToCheck) ? (
    <LinkButton {...props} url={() => getCreateUrl(getValue() as string)}>
      Publish
    </LinkButton>
  ) : null;
};

export default PublishVacancyButton;
